import { getPlaces } from '@rideiq/api/services/Locations';
import * as Constants from '@rideiq/constants';
import { useQuery } from '@tanstack/react-query';

export const PLACES_QUERY_KEY = 'places';

export const usePlacesQuery = (query: string | undefined) => {
  const { data, isFetching } = useQuery({
    queryKey: [PLACES_QUERY_KEY, query],
    queryFn: async ({ signal }) => {
      const response = await getPlaces({ page: 1, perPage: Constants.ITEM_LIMIT_PER_PAGE, q: query }, signal);

      if (response.type === 'error') {
        throw new Error(response.error.errors[0] ?? 'Failed to load places');
      }

      return response.data;
    },
    enabled: !!query && query.length >= Constants.MINIMUM_SEARCH_STRING_LENGTH,
  });

  return {
    places: data?.locations ?? [],
    isLoading: isFetching,
  };
};
